import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable, map, tap } from 'rxjs';
import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';

export const supllierDataResolver: ResolveFn<any[]> = (route, state) => {

  const apiService = inject(ApiService);
  return apiService.getSupplierData(); 

};